// src/utils/haptics.js
import { Capacitor } from "@capacitor/core";
import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";

function isNative() {
    return Capacitor.isNativePlatform();
}

export async function hapticLight() {
    if (!isNative()) return;
    try {
        await Haptics.impact({ style: ImpactStyle.Light });
    } catch (_) { }
}

export async function hapticMedium() {
    if (!isNative()) return;
    try {
        await Haptics.impact({ style: ImpactStyle.Medium });
    } catch (_) { }
}

export async function hapticHeavy() {
    if (!isNative()) return;
    try {
        await Haptics.impact({ style: ImpactStyle.Heavy });
    } catch (_) { }
}

export async function hapticSuccess() {
    if (!isNative()) return;
    try {
        await Haptics.notification({ type: NotificationType.Success });
    } catch (_) { }
}

export async function hapticWarning() {
    if (!isNative()) return;
    try {
        await Haptics.notification({ type: NotificationType.Warning });
    } catch (_) { }
}

export async function hapticError() {
    if (!isNative()) return;
    try {
        await Haptics.notification({ type: NotificationType.Error });
    } catch (_) { }
}

export async function hapticSelection() {
    if (!isNative()) return;
    try {
        await Haptics.selectionStart();
        await Haptics.selectionChanged();
        await Haptics.selectionEnd();
    } catch (_) { }
}